
export enum OnDeleteOption {
    ignore,
    cascade
}
